import Vue from "vue";
import VueI18n from "vue-i18n";
// import md5 from "md5";

Vue.use(VueI18n);

function loadLocaleMessages() {

	/*
	let api_key = 'Up0Gzd35PERs3v3Mr4Gv2wgtPubr73wR';
	let api_secret = 'DgxUWjnxGLKWNzOKS5a3d8ZVAtnSMN1f';
	let unix_timestamp = Math.round((new Date()).getTime() / 1000);
	let query = new URLSearchParams({
		api_key: api_key,
		timestamp: unix_timestamp,
		dev_hash: md5(unix_timestamp.toString() + api_secret),

		locale: 'en-US',
		source_file_name: 'content_sheet_v01.json',
		// export_file_name: 'en.json',
	});

	let project_group_id = '68433';
	let project_id = '183870';
	let file_name = 'content_sheet_v01.xlsx';

	// let url = `/onesky/1/project-groups/?${query}`;
	// let url = `/onesky/1/project-groups/${project_group_id}/projects`;

	// let url = `/onesky/1/projects/${project_id}/languages`; // Use to find all languages
	// let url = `/onesky/1/projects/${project_id}/files`;

	let url = `/onesky/1/projects/${project_id}/translations/multilingual`;

	fetch(url + '?' + query, {
		method: 'GET',
		headers: { 'content-type': 'application/json' }
	})
		.then(response => response.json())
		.then(response => {
			if (response.meta.status == 200) {
				console.log("RESPONSE", response.data);
			}
			else {
				console.error("Onesky error:", response.meta.message);
			}
		});
	*/

	const locales = require.context(
		"@/assets/locales",
		true,
		/[A-Za-z0-9-_,\s]+\.json$/i
	);
	const messages = {};
	locales.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matched && matched.length > 1) {
			const locale = matched[1];
			messages[locale] = locales(key);
		}
	});
	return messages;
}

export default new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || "sv-SE",
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "sv-SE",
	messages: loadLocaleMessages()
});
